import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_ASSET } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("AssetDAO.getListOptions - input:", input);
  const companyId = input?.companyId || null;
  return getLookupList(ENTITY_NAME_ASSET, { companyId })
}
